import React from 'react'
import { Card } from 'react-bootstrap'
import { connect } from 'react-redux'
import moment from 'moment'
import OperacionAdelantoDeCupos from './OperacionAdelantoDeCupos'

const AdelantosProgramados = (props) => {
  const { cerealesAdelanto, limiteCupoDesde, limiteCupoHasta } = props
  const limiteDesde = moment(limiteCupoDesde).format('DD/MM/YY HH:mm')
  const limiteHasta = moment(limiteCupoHasta).format('DD/MM/YY HH:mm')

  return (
    <>
      <h6 style={{ fontWeight: 'bold' }}>Adelanto programado</h6>
      <Card className='shadow rounded card-adelantos-programados'>
        <Card.Body style={{ padding: '0.65rem' }}>
          { (limiteCupoDesde && limiteCupoHasta && cerealesAdelanto && cerealesAdelanto.length > 0)
            ? <table style={{ width: '98%' }}>
              <thead>
                <tr>
                  <th>Cereal</th>
                  <th>Fecha de cupo</th>
                  <th>Fecha limite de cupo</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{cerealesAdelanto}</td>
                  <td>{limiteDesde}</td>
                  <td>{limiteHasta}</td>
                  <td>
                    <OperacionAdelantoDeCupos handleDelete={props.eliminarAdelantoProgramado} />
                  </td>
                </tr>
              </tbody>
            </table>
            : <div>
              <span>No se encontraron adelantos programados</span>
            </div>
          }
        </Card.Body>
      </Card>
    </>
  )
}

const mapStateToProps = state => {
  return {
    cerealesAdelanto: state.cupos.cerealesAdelanto,
    limiteCupoDesde: state.cupos.limiteCupoDesde,
    limiteCupoHasta: state.cupos.limiteCupoHasta
  }
}

export default (connect(mapStateToProps, null)(AdelantosProgramados))
